import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { configure } from 'mobx'
import App from './App'
import './i18n'
import stores from './stores'
import { Provider } from 'mobx-react'
import './yup-custom'
import '@fortawesome/fontawesome-free/css/all.min.css'
import StoresContext from 'Contexts/StoresContext'
import RootStore from 'stores/RootStore'
import { APP_NAME, APP_VERSION } from 'config/env'

configure({ enforceActions: 'never' })

function setAppAndVersionOnLs() {
  localStorage.setItem('84929976-3de4-4670-8434-d97312b3256c', APP_NAME)
  localStorage.setItem('60318a0c-69cc-474a-bc19-010507c1127f', APP_VERSION)
}

const lsAppName = localStorage.getItem('84929976-3de4-4670-8434-d97312b3256c')
const lsAppVersion = localStorage.getItem('60318a0c-69cc-474a-bc19-010507c1127f')

if (lsAppName === null || lsAppVersion === null) {
  stores.authStore.logout()
  setAppAndVersionOnLs()
}
if (APP_NAME !== lsAppName || APP_VERSION !== lsAppVersion) {
  stores.authStore.logout()
  setAppAndVersionOnLs()
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <StoresContext.Provider value={RootStore}>
    <Provider {...stores}>
      {/* StrictMode omitted: Blueprint 3 DateInput still uses findDOMNode / legacy context */}
      <Suspense fallback={<div></div>}>
        <App />
      </Suspense>
    </Provider>
  </StoresContext.Provider>
)
